'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _catalogRegistration = require('../../redux/modules/catalogRegistration');

var _modal = require('../../redux/modules/modal');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterLink = require('./RegisterLink');

var _RegisterLink2 = _interopRequireDefault(_RegisterLink);

var _registerForCatalog = require('../../redux/modules/registerForCatalog');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterLinkContainer = (_dec = (0, _reactRedux.connect)(function (state, props) {
    var registrationStatus = (0, _catalogRegistration.getUserCatalogRegistration)(state, props.catalogId);
    return {
        registrationStatus: registrationStatus
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openRegisterForCatalogModal: _modal.openRegisterForCatalogModal,
        requestOnlineBidding: _registerForCatalog.submitRegisterForCatalog
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(RegisterLinkContainer, _Component);

    function RegisterLinkContainer() {
        (0, _classCallCheck3.default)(this, RegisterLinkContainer);
        return (0, _possibleConstructorReturn3.default)(this, (RegisterLinkContainer.__proto__ || (0, _getPrototypeOf2.default)(RegisterLinkContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(RegisterLinkContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'catalogId', 'isCatalogOnly', 'registrationStatus']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogId = _props.catalogId,
                className = _props.className,
                isCatalogOnly = _props.isCatalogOnly,
                registrationStatus = _props.registrationStatus;


            return (0, _jsx3.default)(_RegisterLink2.default, {
                catalogId: catalogId,
                className: className,
                isCatalogOnly: isCatalogOnly,
                openRegisterForCatalogModal: this.props.openRegisterForCatalogModal,
                registrationStatus: registrationStatus,
                requestOnlineBidding: this.props.requestOnlineBidding
            });
        }
    }]);
    return RegisterLinkContainer;
}(_react.Component)) || _class);
exports.default = RegisterLinkContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RegisterLink/RegisterLinkContainer.js
// module id = TMJx
// module chunks = 46